"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = prop;
const Druid_1 = require("../../Druid");
const PropTypeGuard_1 = require("../../Types/PropTypeGuard");
/**
 * HTML property value binding. Reading settings from html template
 *
 * HTML:
 * <div data-view="ExampleView" data-example-id="20">
 *
 * Typescript:
 * class ExampleView extends View {
 *     @prop exampleId: number = 0;
 * }
 *
 * The property will be available after the "mounted()" function is called
 */
function prop(...types) {
    return (target, propertyKey) => {
        Object.defineProperty(target, propertyKey, {
            get() {
                return this[`_${propertyKey}`];
            },
            set(newValue) {
                if (PropTypeGuard_1.default.isOfType(newValue, types) === false) {
                    throw new Error(`Type '${typeof newValue}' is not assignable to type ${types.join(', ')} for property: ${propertyKey}.`);
                }
                this[`_${propertyKey}`] = newValue;
            },
        });
        Druid_1.default.getViewFramework().registerPropertyDecorator(target, propertyKey, types);
    };
}
//# sourceMappingURL=Prop.js.map